import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';

const PanelButton = styled(Button)`
  border: none !important;
  font-size: 20px !important;
`;

const Action = ({ icon, onClick }) => (
  <PanelButton onClick={onClick} shape="circle" icon={icon} ghost />
);

export default Action;
